import { Component } from '@angular/core';
import { StackLayoutComponent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-logo-shared',
  standalone: true,
  imports: [StackLayoutComponent],
  templateUrl: './logo-shared.component.html',
  styleUrl: './logo-shared.component.scss',
})
export class LogoSharedComponent {
  // private whiteSm = 'logos/logo_white_sm.png';
  private min = 'logos/logo_min.svg';
  protected alt = 'Logo for Alaska Housing Finance Corporation';

  protected getLogo() {
    return this.min;
  }
}
